import qs from 'qs';

// search is optional and if exists gets selectedOptions parsed
export function getQueryParams(search) {
  const localSearch = search || window.location.search;
  if (localSearch.length === 0) {
    return '';
  }

  const rawParams = qs.parse(localSearch.substr(1));
  return { ...rawParams, selectedOptions: rawParams.selectedOptions ? JSON.parse(rawParams.selectedOptions) : {} };
}

export function getQueryParam(param) {
  const params = getQueryParams();
  return params[param] || '';
}

export function isLocalhost() {
  return /localhost|127\.0\.0\.1|::1/.test(window.location.hostname);
}

// testing regex: https://regex101.com/r/EJ5DAR/2
export function isBranchOrStagingEnv() {
  return /staging/.test(window.location.hostname)
    || /https:\/\/[^.]*\.albelli\.design\.vpsvc\.com/.test(window.location.origin);
}

export function isCareAgent() {
  const urlParams = getQueryParams();

  return urlParams.careAgent === 'true';
}

export function isDevelopmentMode() {
  return (
    window.location.href.indexOf('localhost') >= 0
    || window.location.href.indexOf('staging.albelli.design.vpsvc.com') >= 0
  );
}
